import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M27.4904 0.621034C27.6831 0.424407 27.9131 0.268202 28.1669 0.161564C28.4207 0.0549268 28.6933 0 28.9686 0C29.2439 0 29.5165 0.0549268 29.7703 0.161564C30.0241 0.268202 30.2541 0.424407 30.4468 0.621034C31.2544 1.43709 31.2657 2.75577 30.4751 3.58595L13.7784 23.3238C13.5888 23.532 13.3587 23.6993 13.1023 23.8155C12.8458 23.9317 12.5684 23.9944 12.2869 23.9996C12.0054 24.0049 11.7258 23.9527 11.4651 23.8462C11.2045 23.7397 10.9683 23.5812 10.7711 23.3803L0.611314 13.085C0.219486 12.6854 0 12.148 0 11.5884C0 11.0287 0.219486 10.4914 0.611314 10.0918C0.804022 9.89519 1.03402 9.73898 1.28785 9.63235C1.54167 9.52571 1.81422 9.47078 2.08954 9.47078C2.36485 9.47078 2.6374 9.52571 2.89123 9.63235C3.14505 9.73898 3.37505 9.89519 3.56776 10.0918L12.1858 18.8256L27.4339 0.683156C27.4515 0.661333 27.4703 0.640588 27.4904 0.621034Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }